import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { 
  UserIcon,
  CreditCardIcon, 
  ChartBarIcon, 
  ChatBubbleLeftRightIcon,
  Bars3Icon,
  XMarkIcon
} from '@heroicons/react/24/outline'

function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const location = useLocation()

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: UserIcon },
    { name: 'Redemptions', href: '/redemptions', icon: CreditCardIcon },
    { name: 'Analytics', href: '/analytics', icon: ChartBarIcon },
    { name: 'AI Chatbot', href: '/chatbot', icon: ChatBubbleLeftRightIcon },
  ]

  const isActive = (href) => {
    if (href === '/dashboard') {
      return location.pathname === '/dashboard'
    }
    return location.pathname.startsWith(href)
  }

  return (
    <>
      {/* Mobile overlay */}
              <div className={'lg:hidden fixed inset-0 bg-gray-600 bg-opacity-75 z-40 transition-opacity ' + (
          isCollapsed ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )} onClick={() => setIsCollapsed(false)} />

      {/* Sidebar */}
              <div className={'fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 transform transition-transform duration-300 ease-in-out lg:translate-x-0 ' + (
          isCollapsed ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        )}>
        <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-purple-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">PF</span>
            </div>
            <span className="text-lg font-bold text-gray-900">Points FYI</span>
          </div>
          
          {/* Mobile close button */}
          <button
            className="lg:hidden p-1 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100"
            onClick={() => setIsCollapsed(false)}
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        <nav className="mt-8 px-4">
          <div className="space-y-2">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={'group flex items-center px-3 py-3 text-sm font-medium rounded-lg transition-colors ' + (
                  isActive(item.href)
                    ? 'bg-primary-50 text-primary-700 border-r-2 border-primary-700'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                )}
              >
                <item.icon
                  className={'mr-3 h-5 w-5 flex-shrink-0 ' + (
                    isActive(item.href)
                      ? 'text-primary-700'
                      : 'text-gray-400 group-hover:text-gray-500'
                  )}
                />
                {item.name}
              </NavLink>
            ))}
          </div>

          {/* Quick Stats */}
          <div className="mt-8 px-3">
            <div className="bg-gradient-to-br from-primary-50 to-purple-50 rounded-lg p-4">
              <h3 className="text-sm font-medium text-gray-900 mb-2">Quick Stats</h3>
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Total CPP</span>
                  <span className="font-medium text-primary-700">2.4¢</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Redemptions</span>
                  <span className="font-medium text-primary-700">12</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Value Saved</span>
                  <span className="font-medium text-success-600">$2,847</span>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>

      {/* Mobile menu button */}
      <div className="lg:hidden fixed top-4 left-4 z-50">
        <button
          className="p-2 bg-white rounded-lg shadow-lg border border-gray-200 text-gray-600 hover:text-gray-900"
          onClick={() => setIsCollapsed(true)}
        >
          <Bars3Icon className="w-6 h-6" />
        </button>
      </div>
    </>
  )
}

export default Sidebar
